var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.deadLineDateText)?_c('p',{class:['m-0 p-0 text-lowercase small', { 'text-danger': !_vm.isAfter }]},[_vm._v(_vm._s(_vm.$t('views.excmcase.show.deadline'))+" "+_vm._s(_vm.deadLineDateText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }